import React from "react";

import { LogoVend } from "~misc/icons";
import { initialPath } from "~misc/paths";
import { HomeIcon } from "~misc/icons";

import "./styles.scss";

const ErrorsLayout = ({ title, description, hideBack, hideRefresh, hideHome }) => {
  const handleHome = () => {
    window.location.href = "/";
  };

  const handleBack = () => {
    window.history.back();
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <main className="error-page">
      <div className="content container">
        <LogoVend className="logo" />

        <h1 className="title">{title}</h1>
        <p className="description">{description}</p>

        <div className="buttons-row">
          {!hideBack && (
            <button onClick={handleBack} className="link back-link bg-primaria">
              Voltar para página anterior
            </button>
          )}

          {!hideRefresh && (
            <button onClick={handleRefresh} className="link refresh-link bg-primaria">
              Tentar novamente
            </button>
          )}
        </div>

        {!hideHome && (
          <button onClick={handleHome} className="link home-link bg-primaria">
            <HomeIcon />
            Voltar para o início
          </button>
        )}
      </div>
    </main>
  );
};

export default ErrorsLayout;
